import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, withCtx as _withCtx, createBlock as _createBlock, createTextVNode as _createTextVNode, vShow as _vShow } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "microservice-modules"
}
const _hoisted_2 = { class: "mb-0" }
const _hoisted_3 = { class: "microservice-module-description" }
const _hoisted_4 = ["innerHTML"]
const _hoisted_5 = { class: "microservice-module-price" }
const _hoisted_6 = { class: "microservice-module-toggle" }
const _hoisted_7 = {
  key: 0,
  class: "d-flex mb-1"
}
const _hoisted_8 = { class: "mr-1" }
const _hoisted_9 = { class: "microservice-duration" }
const _hoisted_10 = ["innerHTML"]
const _hoisted_11 = { class: "" }
const _hoisted_12 = { class: "row" }
const _hoisted_13 = { key: 0 }
const _hoisted_14 = { class: "mb-1" }
const _hoisted_15 = {
  key: 1,
  class: "text-muted d-flex"
}
const _hoisted_16 = { class: "price-label" }
const _hoisted_17 = { class: "flex-shrink-0" }
const _hoisted_18 = /*#__PURE__*/_createElementVNode("hr", { class: "my-1" }, null, -1)
const _hoisted_19 = { class: "text-muted lead text-right" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_InputSwitch = _resolveComponent("InputSwitch")!
  const _component_ProductPageContentSection = _resolveComponent("ProductPageContentSection")!
  const _component_ProductOverviewItemCard = _resolveComponent("ProductOverviewItemCard")!
  const _component_PriceSummary = _resolveComponent("PriceSummary")!
  const _component_Message = _resolveComponent("Message")!
  const _component_WalletMessage = _resolveComponent("WalletMessage")!
  const _component_ProductPageSummary = _resolveComponent("ProductPageSummary")!
  const _component_ProductLayout = _resolveComponent("ProductLayout")!
  const _component_ProductAddedModal = _resolveComponent("ProductAddedModal")!
  const _directive_lazy = _resolveDirective("lazy")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_ProductLayout, { vm: _ctx.vm }, {
      summary: _withCtx(() => [
        _createVNode(_component_ProductPageSummary, {
          "can-submit": !_ctx.submitted && _ctx.linesTotal() !== 0,
          "is-product-available": _ctx.vm.viewModelIsValid,
          "total-price": _ctx.priceSummary?.totalPrice,
          onAddToCart: _cache[0] || (_cache[0] = ($event: any) => (_ctx.addMicroServiceProductToCart())),
          class: "product-summary"
        }, {
          priceSummary: _withCtx(() => [
            (_ctx.isMicroService())
              ? (_openBlock(), _createElementBlock("p", _hoisted_13, _toDisplayString(_ctx.$t('enum.itemProductType.' + _ctx.vm.productType)), 1))
              : _createCommentVNode("", true),
            _createElementVNode("h5", _hoisted_14, _toDisplayString(_ctx.vm.title), 1),
            (!_ctx.isMicroService())
              ? (_openBlock(), _createElementBlock("p", _hoisted_15, [
                  _createElementVNode("span", _hoisted_16, _toDisplayString(_ctx.linesTotal()) + " x " + _toDisplayString(_ctx.linesTotal() > 1 ? _ctx.$t("microservice.summary.modules") : _ctx.$t("microservice.summary.module")), 1),
                  _createElementVNode("span", _hoisted_17, _toDisplayString(_ctx.formatCurrency(_ctx.priceSummary.totalPrice)), 1)
                ]))
              : _createCommentVNode("", true),
            _hoisted_18,
            _createVNode(_component_PriceSummary, { vm: _ctx.priceSummary }, null, 8, ["vm"]),
            _createElementVNode("p", _hoisted_19, _toDisplayString(_ctx.$t("common.productSummary.allPricesExclVat")), 1)
          ]),
          validationMessage: _withCtx(() => [
            (_ctx.linesTotal() === 0)
              ? (_openBlock(), _createBlock(_component_Message, {
                  key: 0,
                  id: _ctx.validation - _ctx.msg - _ctx.micro - _ctx.service - _ctx.product - _ctx.atleast - _ctx.one - _ctx.sum,
                  closable: false,
                  severity: "error"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t("common.message.error.atLeastOne")), 1)
                  ]),
                  _: 1
                }, 8, ["id"]))
              : _createCommentVNode("", true)
          ]),
          walletMessage: _withCtx(() => [
            _withDirectives(_createVNode(_component_WalletMessage, {
              "wallet-amount": _ctx.calculateWalletAmount()
            }, null, 8, ["wallet-amount"]), [
              [_vShow, !_ctx.isSmallScreen && _ctx.vm?.canUseWallet && parseInt(_ctx.calculateWalletAmount()) !== 0]
            ])
          ]),
          _: 1
        }, 8, ["can-submit", "is-product-available", "total-price"])
      ]),
      default: _withCtx(() => [
        (_ctx.selectableModules.length > 1)
          ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
              _createElementVNode("h2", _hoisted_2, _toDisplayString(_ctx.$t("microservice.modules.title")), 1),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.selectableModules, (item) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: item.id,
                  class: "microservice-module"
                }, [
                  _createElementVNode("div", _hoisted_3, [
                    _createElementVNode("strong", null, _toDisplayString(item.title), 1),
                    _createElementVNode("p", null, [
                      _createElementVNode("em", null, _toDisplayString(_ctx.$tc("microservice.modules.variation.duration", item.durationInMinutes)), 1)
                    ]),
                    _createElementVNode("div", {
                      class: "microservice-module-description-content",
                      innerHTML: item.description
                    }, null, 8, _hoisted_4)
                  ]),
                  _createElementVNode("div", _hoisted_5, _toDisplayString(_ctx.formatCurrency(item.basePrice)), 1),
                  _createElementVNode("div", _hoisted_6, [
                    _createVNode(_component_InputSwitch, {
                      modelValue: item.checked,
                      "onUpdate:modelValue": ($event: any) => ((item.checked) = $event),
                      onChange: ($event: any) => (_ctx.onToggleSelectionClicked(item))
                    }, null, 8, ["modelValue", "onUpdate:modelValue", "onChange"])
                  ])
                ]))
              }), 128))
            ]))
          : _createCommentVNode("", true),
        _createVNode(_component_ProductPageContentSection, { type: "media" }, {
          default: _withCtx(() => [
            (_ctx.isMicroService() && _ctx.selectableModules?.[0]?.durationInMinutes)
              ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                  _withDirectives(_createElementVNode("img", _hoisted_8, null, 512), [
                    [_directive_lazy, '/Static/images/icons/clock.svg']
                  ]),
                  _createElementVNode("div", _hoisted_9, _toDisplayString(_ctx.$tc("common.minutes", _ctx.selectableModules?.[0]?.durationInMinutes)), 1)
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("div", {
              class: "content rte",
              innerHTML: _ctx.vm.description
            }, null, 8, _hoisted_10)
          ]),
          _: 1
        }),
        (_ctx.vm.relatedUpSellProducts?.length)
          ? (_openBlock(), _createBlock(_component_ProductPageContentSection, {
              key: 1,
              type: "upsell",
              class: "upsell-block"
            }, {
              default: _withCtx(() => [
                _createElementVNode("h3", _hoisted_11, _toDisplayString(_ctx.$t("product.titleUpSell")), 1),
                _createElementVNode("div", _hoisted_12, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.vm.relatedUpSellProducts, (product) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: product,
                      class: "col-md-6 mb-2"
                    }, [
                      _createVNode(_component_ProductOverviewItemCard, {
                        item: product,
                        layout: "grid"
                      }, null, 8, ["item"])
                    ]))
                  }), 128))
                ])
              ]),
              _: 1
            }))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["vm"]),
    (_ctx.cartStore.showProductAddedModal)
      ? (_openBlock(), _createBlock(_component_ProductAddedModal, {
          key: 0,
          vm: _ctx.productAddedVm
        }, null, 8, ["vm"]))
      : _createCommentVNode("", true)
  ], 64))
}